import { Autocomplete, TextField } from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';

export default function SingleSelector({ value, onChange, options, label, placeholder, id, getOptionLabel }) {
  const [inputValue, setInputValue] = useState('');
  return (
    <>
      <Autocomplete
        freeSolo
        value={value}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        id={id}
        options={options}
        getOptionLabel={getOptionLabel}
        filterSelectedOptions
        renderInput={(params) => <TextField {...params} label={label} placeholder={placeholder} />}
      />
    </>
  );
}

SingleSelector.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};
